import { render, staticRenderFns } from "./OceanoAyceSection.vue?vue&type=template&id=035eda0e&scoped=true"
import script from "./OceanoAyceSection.vue?vue&type=script&lang=ts"
export * from "./OceanoAyceSection.vue?vue&type=script&lang=ts"
import style0 from "./OceanoAyceSection.vue?vue&type=style&index=0&id=035eda0e&prod&lang=css"
import style1 from "./OceanoAyceSection.vue?vue&type=style&index=1&id=035eda0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035eda0e",
  null
  
)

export default component.exports